import { shape, string } from 'prop-types';

const openCloseShape = shape({
  open: string,
  close: string
});

const storeHoursShape = shape({
  sunday: openCloseShape,
  monday: openCloseShape,
  tuesday: openCloseShape,
  wednesday: openCloseShape,
  thursday: openCloseShape,
  friday: openCloseShape,
  saturday: openCloseShape
});

export const storeShape = shape({
  address: shape({
    city: string,
    country: string,
    postalCode: string,
    state: string,
    street: string
  }),
  storeHours: storeHoursShape,
  curbsidePickupHours: storeHoursShape,
  proDeskHours: storeHoursShape,
  toolRentalHours: storeHoursShape,
  distance: string,
  name: string,
  phone: string,
  proDeskPhone: string,
  storeDetailsPageLink: string,
  storeId: string,
  toolRentalPhone: string
});
